import { bl_fi_einvoice_printable_email_thread_RowClass } from '../../dbschema/bl_fi_einvoice_printable_email_thread.model';
import { BaseContainerModel } from '../base-container.model';

export class EinvoicePrintableEmailThreadContainerModel extends BaseContainerModel {
    bl_fi_einvoice_printable_email_thread: bl_fi_einvoice_printable_email_thread_RowClass = new bl_fi_einvoice_printable_email_thread_RowClass();
}